import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import cx from 'classnames';
import App from 'components/App/App';

import s from './Root.module.scss';

const Root = () => (
  <div className={cx(s.Root)}>
    <BrowserRouter basename="/cook">
      <App />
    </BrowserRouter>
  </div>
);

export default Root;
